import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-391d50fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-image",
  src: "//res-cn.public.gblinker.com/gblinker/wechat_mini/images/111536d1f1438bb09a5ec64afc7ca0d02.png",
  mode: "widthFix"
}, null, -1))
const _hoisted_2 = { class: "btn-context" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "desc"
}
const _hoisted_5 = {
  key: 1,
  class: "desc"
}
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = {
  key: 2,
  class: "desc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "g-card receiver-address-btn",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateTo && _ctx.navigateTo(...args)))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('默认收件人信息')), 1),
      (!_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 登录填写收件人信息 "))
        : (_ctx.hasAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.defaultAddress.firstname), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.defaultAddress.mobile), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.defaultAddressDetail), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('当前无默认收件人信息，请点击设置')), 1))
    ])
  ]))
}